import { Save } from 'react-feather'

export default [
  {
    id: 'mobileView',
    title: 'Search IMEI  ',
    icon: <Save size={20} />,
    navLink: 'transaction/mobileView'
  }
]